
import { Box, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { InformationCardHOC } from '../components';
import TranslationMessage from './transMessage';
import InfoIcon from '../../../assets/images/svgs/darkInfoRed.svg'
import { theme } from '../../../utils/theme/godzilla_light';
import { useAuth } from '../../../contexts';
import { useNavigate } from 'react-router-dom';
import { supportMailUrl } from '../../../constants';

interface IErrorProps {
    errorType: string;
}

export const ErrorComponent = (props: IErrorProps) => {
    const { t } = useTranslation();
    const { logout } = useAuth();
    const navigate = useNavigate();

    const { errorType } = props

    const errorContent = errorType == "logout" ? t(TranslationMessage.VALIDATION_ERROR_LOGOUT) : t(TranslationMessage.VALIDATION_ERROR)
    const btnLabel = errorType == "logout" ? t(TranslationMessage.LOGOUT_BUTTON_LABEL) : t(TranslationMessage.BACK_TO_PROFESSIONAL_BUTTON_LABEL)

    const onClickAction = () => {
        if (errorType == "logout") {
            logout()
            return
        }
        navigate("/professional-information")
    }

    return (
        <InformationCardHOC
            infoTitle={"Validation Error"}
            buttonText={btnLabel}
            onClickBtn={onClickAction}
            iconComponent={<img src={InfoIcon} alt='info-icon' style={{ width: "55px", height: "55px", marginBottom: "16px" }} />}>
            <Box component={'form'} sx={{ mt: "1rem", px: "1.5rem" }}>
                <Typography sx={{
                    ...theme.typography.poppinsBodyRegular, textAlign: "left", fontSize: '20px',
                    lineHeight: '27.24px', color: "#1E1E23"
                }}>
                    <Trans
                        i18nKey={errorContent}
                        components={{
                            bold: <strong />,
                            br: <br />,
                            // eslint-disable-next-line
                            a: <a
                                    href={`mailto:${supportMailUrl}`}
                                    style={{ ...theme.typography.poppinsBodyRegular, fontWeight:500,fontSize: "20px", lineHeight: "27.24px", color: "#1E1E23", textUnderlineOffset: "6px", textDecorationColor: theme.palette.primary.main, textDecorationThickness: "2px" }}
                                ></a>
                        }}
                    />
                </Typography>
            </Box>
        </InformationCardHOC>
    );
}